import { Modal, Row, Col, Form } from 'react-bootstrap'
import {useState, useEffect, useContext} from 'react'
import CurrencyInput from '../formElements/CurrencyInput'
import {FormInput} from '../formElements/FormInput'
import "react-datepicker/dist/react-datepicker.css"
import {validateFormFields} from '../../utils'
import IssueAuthorizationService from '../../services/IssueAuthorizationService'
import CommonService from '../../services/CommonService'
import { UserContext, IssuerContext } from '../../UserContext'
import AddAuthorizationRef from './addAuthorizationRef'
import { toast } from 'react-toastify'

const EditIssuanceAuthorization = (props) => {
    const {onModalClose, authInfo, issueId} = props;
    const user = useContext(UserContext);
    const issuerId = useContext(IssuerContext);
    const [formErrors,setFormErrors] = useState({});
    const [authorizationNames, setAuthorizationNames] = useState([]);
    const [authorizationInfo, setAuthorizationInfo] = useState({...authInfo,  'outstandingAmt': ''});
    const [netChange, setNetChange] = useState(0.00);
    const [addNewAuthorization, setAddNewAuthorization] = useState(false);
    const getAuthorizationRefLookups = () => {
        var obj = {
            "msgId": null,
            "sysId": null,
            "opr": "getAuthorizationRefLookupsByIssuerId",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {"id": issuerId}
        };
    
        IssueAuthorizationService.getAuthorizationsByIssuerId(obj)
        .then((res) => res)
        .then((result) => {
            setAuthorizationNames(result.data.responses[0]);
            setAuthorizationInfo({...authorizationInfo, 'outstandingAmt' : result.data.responses[0].filter(el => el.authorizationId === authorizationInfo.authorizationId)[0].outstandingAmount})
        });
    }
    useEffect(() => {
        getAuthorizationRefLookups();  
        // eslint-disable-next-line
    }, []);

    useEffect(()=> {
        const net = (authInfo.authorityReplenishAmt - authInfo.authorityReducedAmt)
        setNetChange(net)
    },[authInfo]);
    
    const getAuthorizationRef = (authorizationId, authArray) => {
        var obj = {
            "msgId": null,
            "sysId": null,
            "opr": "getAuthorizationRef",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {"authorizationId": authorizationId}
        };
    
        IssueAuthorizationService.getAuthorizationRef(obj)
            .then((res) => res)
            .then((result) => {
            if(result.data.errors && result.data.errors.length > 0){
                toast.error(result.data.errors[0].message)
            } else {
                setAuthorizationInfo({...authArray, 
                    'originalAuthorizedAmt': result.data.responses[0].authorizationAmt,
                    'authorizationDate': result.data.responses[0].electionDate
                });
            }
        });
    }

    const handleAuthChange = (e) => {
        const {name, value} = e.target;
        let authArray = {...authorizationInfo};
        if(name === 'authorizationName'){
            authArray['authorizationId'] = value;
            const outstandingAmount = authorizationNames.filter(el => el.authorizationId === parseInt(value))[0].outstandingAmount;
            authArray['outstandingAmt'] = outstandingAmount;
            getAuthorizationRef(parseInt(value), authArray);
        } else {
            authArray[name] = value;
        }
        setAuthorizationInfo(authArray);
    }

    const handleAddNewAuthorization = () => {
        setAddNewAuthorization(true);
    }

    const handleAddNewAuthClose = () => {
        setAddNewAuthorization(false);
        getAuthorizationRefLookups();
    }

    const calculateNetChange = () => {
        let authArray = {...authorizationInfo};
        const authorityReplenishAmt = ( typeof authArray.authorityReplenishAmt === 'string' ) 
            ? authArray['authorityReplenishAmt'] !== "" ? parseFloat(authArray['authorityReplenishAmt'].replace(/,/g, '')) : 0.00
            : authArray['authorityReplenishAmt'] !== "" ? authArray['authorityReplenishAmt'] : 0;    
    
        const authorityReducedAmt = ( typeof authArray.authorityReducedAmt === 'string' ) 
            ? authArray['authorityReducedAmt'] !== "" ? parseFloat(authArray['authorityReducedAmt'].replace(/,/g, '')) : 0.00
            : authArray['authorityReducedAmt'] !== "" ? authArray['authorityReducedAmt'] : 0;    
       
        let netChangeTotal = (authorityReplenishAmt*10 - authorityReducedAmt*10)/10;
        setNetChange(netChangeTotal);
    }
  
    const updateAuthorization = async (issueAuthorization) => {  
        let obj = {
            "msgId": null,
            "sysId": null,
            "opr": "putIssueAuthorization",
            "hdrStruct": null,
            "queryParam": null,
            "reqData": {
                "id" : issueAuthorization.issuerAuthorizationId,
                "issueAuthorization": {
                    "authorizationId": issueAuthorization.authorizationId,
                    "finalSaleId": null,
                    "proposeDebtId": issueId,
                    "originalAuthorizedAmt": issueAuthorization.originalAuthorizedAmt,
                    "authorizationDate": issueAuthorization.authorizationDate,
                    "otherAuthorizationName": issueAuthorization.otherAuthorizationName,
                    "authorityReplenishAmt": issueAuthorization.authorityReplenishAmt,
                    "authorityReducedAmt": issueAuthorization.authorityReducedAmt,
                    "createDatetime": new Date(),
                    "createUser": CommonService.getUserName(user),
                    "lastUpdateDatetime": new Date(),
                    "lastUpdateUser": CommonService.getUserName(user)
                }
            }
        };
       
        await IssueAuthorizationService.updateAuthorization(obj)
        .then((res) => res)
        .then((result) => {
        });
    }

    const handleSubmit = (e) => {
        const form = e.target.closest('form#edit-form');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {
            setFormErrors({});
            updateAuthorization(authorizationInfo);
            onModalClose();
        }
    }
    return (
        <Modal  show={true} onHide={onModalClose}>
            {addNewAuthorization ?
                <><Modal.Header closeButton><h3>Add New Authorization</h3></Modal.Header>
                <Modal.Body><AddAuthorizationRef onModalClose={handleAddNewAuthClose} /></Modal.Body></> : 
            <><Modal.Header closeButton><h3>Edit Issuance Authorization</h3></Modal.Header>
            <Modal.Body>
                <form id="edit-form">
                    <Row>
                        <Col md={12}>
                            <div className="control">
                                <label><span className="required">*</span>Authorization Name</label>
                                <Form.Select name="authorizationName" 
                                    onChange={(e)=>handleAuthChange(e)} 
                                    data-validations="required"
                                    value={authorizationInfo.authorizationId}
                                    style={formErrors['authorizationName'] && {border: `solid 1px red`}}
                                >
                                    <option value="">select</option>
                                    {authorizationNames.length !== 0 && authorizationNames.map((auth, i) => {
                                        return <option key={i} value={auth.authorizationId}>{auth.authorizationLookupName}</option>
                                    })}
                                </Form.Select>
                                { formErrors && formErrors['authorizationName'] && <p className="error">{ formErrors['authorizationName'] }</p>}
                            </div>
                            <button type="button" className="link-button" onClick={()=>handleAddNewAuthorization()} id="add_new"><small>Add New Authorization</small></button>
                            {addNewAuthorization && <AddAuthorizationRef onModalClose={handleAddNewAuthClose}/>}
                        </Col>
                        <Col md={6}>
                            <div className="control">
                                <FormInput 
                                label="Current Remaining Authorization" 
                                name="outstandingAmt" 
                                value={authorizationInfo.outstandingAmt} 
                                helpText="Outstanding Amount"
                                disabled="disabled"/>
                            </div>
                        </Col>
                        </Row>
                        <Row>
                        <Col md={6}>
                            <div className="control">
                            <FormInput 
                                label="Original Authorized Amount" 
                                name="originalAuthorizedAmt" 
                                value={(authorizationInfo.originalAuthorizedAmt !== '' ? CommonService.currencyFormatter(authorizationInfo.originalAuthorizedAmt) : '')} 
                                helpText="The original maximum amount of debt authorized by the vote of the electorate or action of the governing body."
                                disabled="disabled"/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="control"><span className="required">*</span>
                                <CurrencyInput 
                                    label="Amount Authority Reduced (By this Issue)" 
                                    name="authorityReducedAmt" 
                                    value={authorizationInfo.authorityReducedAmt} 
                                    onBlur={(e)=>calculateNetChange(e)}
                                    onChange={(e)=>handleAuthChange(e)}
                                    helpText="Amount Authority Reduced (By this Issue)"
                                    validations={["required"]}
                                    error ={ formErrors && formErrors['authorityReducedAmt'] }/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="control">
                                <FormInput 
                                label="Authorization Date: (MM/DD/YYYY)" 
                                name="originalAuthorizionDate" 
                                value={authorizationInfo.authorizationDate !== '' ? CommonService.dateFormatter(authorizationInfo.authorizationDate) : ''} 
                                helpText="Authorization Date"
                                disabled="disabled"/>
                            </div>
                        </Col>    
                        <Col md={6}>
                            <div className="control">
                                <span className="required">*</span>
                                <CurrencyInput
                                label="Amount Authority Replenished (By this Issue)" 
                                name="authorityReplenishAmt" 
                                value={authorizationInfo.authorityReplenishAmt} 
                                onBlur={(e)=>calculateNetChange(e)}
                                onChange={(e)=>handleAuthChange(e)}
                                validations={["required"]}
                                error={formErrors && formErrors['authorityReplenishAmt']}
                                helpText="Amount Authority Replenished(By this Issue)"/>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="control">
                                <FormInput type="text" label="Net Change (By this Issue)" 
                                name="netChange" 
                                value={(netChange !== '' ? CommonService.currencyFormatter(netChange) : '')}
                                readOnly
                                disabled="disabled" 
                                helpText="Net Change"/>
                            </div>
                        </Col>                    
                    </Row>

                    <div className="btn-div">
                    <div className="fright">
                    <button type="button" className="btn-secondary custom-button-secondary" onClick={()=>onModalClose()}>Cancel</button>{" "}
                    <button type="button" className="custom-button" onClick={(e)=>handleSubmit(e)}>Save</button>
                    </div>
                </div>
                </form>
            </Modal.Body></>
            }
        </Modal>
    )
}

export default EditIssuanceAuthorization
